import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Leadingcabcompaniesinindia() {



  const cardData =
  {
    keyword: 'Leading Cab Companies in India',
    heading: 'Aaryan Travels: Leading Cab Companies in India',
    headingDescription: ' Aaryan Travels stands among the Leading Cab Companies in India, delivering trusted transportation solutions across major cities including Pune, Mumbai, Delhi, Bangalore, Hyderabad, Chennai, Ahmedabad, and Kolkata. With a diverse fleet of hatchbacks, sedans, SUVs, luxury cars, and tempo travellers, we cater to local travel, airport transfers, corporate mobility, wedding transportation, and long-distance journeys. What sets Aaryan Travels apart is its commitment to punctual service, professional chauffeurs, transparent pricing, and 24/7 availability. From individual riders to corporate groups, we provide safe, reliable, and high-quality cab services nationwide, making Aaryan Travels a preferred choice in India’s organized travel sector.',

    top: 'Top Places to Visit in India with Aaryan Travels',

"topPlaces": [
  {
    "title": "Taj Mahal, Agra",
    "description": "The Taj Mahal is one of the Seven Wonders of the World, built by Emperor Shah Jahan in memory of his beloved wife Mumtaz Mahal. Crafted from white marble with intricate inlay work, it changes color with the light of dawn, dusk, and moonlight. The symmetrical gardens and reflecting pool enhance its grandeur. Millions visit each year to witness its timeless beauty. The Taj Mahal is India’s eternal symbol of love."
  },
  {
    "title": "Golden Temple, Amritsar",
    "description": "The Golden Temple, also known as Harmandir Sahib, is the holiest shrine of Sikhism. Surrounded by a sacred lake, its gold-plated sanctum glows beautifully under sunlight and night illumination. Devotional hymns and peaceful vibes attract visitors from all faiths. The Langar here serves free meals to thousands daily. The Golden Temple is India’s shining beacon of peace and unity."
  },
  {
    "title": "Jaipur City Palace, Rajasthan",
    "description": "City Palace in Jaipur is a magnificent blend of Rajput and Mughal architecture with courtyards, museums, and royal chambers. Highlights include the Peacock Gate, Chandra Mahal, and weapon galleries. It still serves as a residence for the royal family. Painted walls and marble carvings showcase royal luxury. City Palace is India’s regal masterpiece of heritage."
  },
  {
    "title": "Varanasi Ghats, Uttar Pradesh",
    "description": "Varanasi is one of the world’s oldest living cities, famous for its sacred ghats along the Ganga River. Pilgrims perform rituals, take holy dips, and offer prayers at sunrise. The evening Ganga Aarti with lamps and chanting creates a surreal spiritual aura. Narrow alleys and ancient temples add to the mystic charm. Varanasi is India’s eternal city of enlightenment."
  },
  {
    "title": "Backwaters of Kerala, Alleppey",
    "description": "The Kerala Backwaters offer tranquil cruises through lagoons, canals, and paddy fields on traditional houseboats. Visitors relax in cozy floating cottages while enjoying local cuisines. Coconut palms and village life reflect in calm waters beautifully. Sunset views over the backwaters are unforgettable. Alleppey is India’s floating paradise of serenity."
  },
  {
    "title": "Rann of Kutch, Gujarat",
    "description": "The Great Rann of Kutch is a vast white salt desert that sparkles under moonlight. During the Rann Utsav festival, colorful tents, folk dances, and camel rides bring lively culture to the desert. Tourists enjoy sunrise treks and handicraft markets. Night stargazing adds magic to the stay. The Rann is India’s surreal white wonderland."
  },
  {
    "title": "Mysore Palace, Karnataka",
    "description": "Mysore Palace is a royal residence shining with stained glass, marble halls, and ornate domes. Every Sunday and during Dasara festival, it is illuminated with nearly 100,000 bulbs, creating a jaw-dropping spectacle. Inside, visitors admire thrones, sculptures, and paintings. The palace symbolizes the grandeur of the Wodeyar dynasty. Mysore Palace is India’s glowing monument of royalty."
  },
  {
    "title": "Gateway of India, Mumbai",
    "description": "The Gateway of India is a monumental arch built in 1924 facing the Arabian Sea. It marks the ceremonial entry point during British rule. Tourists enjoy ferry rides to Elephanta Caves and scenic views of the sea. Street food and local vendors make the promenade lively. The Gateway of India is Mumbai’s coastal emblem of heritage."
  },
  {
    "title": "Ajanta & Ellora Caves, Maharashtra",
    "description": "Ajanta and Ellora Caves are UNESCO World Heritage rock-cut monuments carved between the 2nd century BCE and 10th century CE. Ajanta features Buddhist paintings and sculptures, while Ellora showcases Hindu, Jain, and Buddhist temples, including the grand Kailasa Temple. Intricate carvings reflect ancient craftsmanship. These caves are India’s epic gallery of stone art."
  },
  {
    "title": "Andaman & Nicobar Islands",
    "description": "The Andaman Islands are known for turquoise waters, coral reefs, and pristine beaches like Radhanagar and Elephant Beach. Water sports such as snorkeling and scuba diving reveal colorful marine life. Cellular Jail offers historical insight with its light-and-sound show. Dense forests and boat rides enhance the tropical experience. Andaman is India’s tropical dream escape."
  }
],


 "services": [
  {
    "name": "Leading Cab Companies in India",
    "description": "Our list of Leading Cab Companies in India features the most reliable and efficient cab service providers known for their wide coverage, quality vehicles, and professional drivers. These companies cater to diverse travel needs, offering everything from local rides to outstation journeys with seamless booking and customer support."
  },
  {
    "name": "Top Taxi Providers India",
    "description": "Top Taxi Providers in India are renowned for their punctuality, safety, and convenience. Offering extensive city and intercity services, they employ modern booking systems and well-maintained fleets to ensure a smooth ride experience across the country."
  },
  {
    "name": "Best Cab Brands India",
    "description": "Best Cab Brands India stand out for their commitment to quality, comfort, and customer satisfaction. These brands offer premium vehicles, professional chauffeurs, and advanced technology integrations like app-based bookings and real-time tracking."
  },
  {
    "name": "Trusted Cab Operators India",
    "description": "Trusted Cab Operators in India are those with proven track records of safety, reliability, and transparency. They emphasize verified drivers, stringent hygiene standards, and responsive customer service to build lasting trust with their users."
  },
  {
    "name": "Premier Cab Services India",
    "description": "Premier Cab Services India provide luxury and executive travel options catering to corporate clients, VIPs, and discerning travelers. Their fleets include high-end sedans and SUVs, complemented by professional chauffeur services for a premium experience."
  },
  {
    "name": "Nationwide Cab Companies",
    "description": "Nationwide Cab Companies cover urban and rural areas across India, offering consistent service quality regardless of location. They support various booking channels, including online, app, and call centers, ensuring easy access to taxis anywhere in the country."
  },
  {
    "name": "Top Rated Taxi Companies India",
    "description": "Top Rated Taxi Companies India are highly reviewed by customers for their punctuality, vehicle condition, and courteous service. These companies consistently deliver efficient rides, safe driving, and transparent pricing."
  },
  {
    "name": "Renowned Cab Firms India",
    "description": "Renowned Cab Firms in India have established their reputation over years of reliable service, innovative offerings, and customer-centric policies. They often partner with businesses for corporate travel and provide customizable transportation solutions."
  },
  {
    "name": "India’s Leading Cab Services",
    "description": "India’s Leading Cab Services are known for combining technology, scale, and quality to meet the country’s diverse mobility demands. Their offerings range from budget-friendly taxis to luxury rides, covering all major cities and towns."
  },
  {
    "name": "Large-scale Cab Networks India",
    "description": "Large-scale Cab Networks India boast extensive vehicle fleets and wide driver pools, ensuring availability even during peak hours and festivals. Their network allows seamless intercity travel and multi-day bookings for business and leisure purposes."
  },
  {
    "name": "Most Popular Cab Companies India",
    "description": "Most Popular Cab Companies India enjoy high customer loyalty due to their consistent performance, ease of use, and affordable pricing. They cater to millions of daily riders across metro and tier-2 cities alike."
  },
  {
    "name": "Elite Cab Operators India",
    "description": "Elite Cab Operators India focus on providing luxury and personalized services for high-net-worth individuals and corporate clients. Their chauffeurs are professionally trained to offer discreet, comfortable, and timely rides."
  },
  {
    "name": "Top Car Hire Firms India",
    "description": "Top Car Hire Firms India specialize in flexible car rental options, including self-drive and chauffeur-driven services. Ideal for corporate events, weddings, and leisure travel, these firms provide a diverse fleet suited for all occasions."
  },
  {
    "name": "High End Cab Networks India",
    "description": "High End Cab Networks India cater to premium travelers seeking sophisticated vehicles and exclusive services. They offer amenities like Wi-Fi, refreshments, and advanced safety features for an exceptional ride experience."
  },
  {
    "name": "Leading Transport Services India",
    "description": "Leading Transport Services India encompass not only cabs but also integrated logistics and passenger transport solutions. They support businesses with large-scale employee mobility and offer end-to-end transport management platforms."
  }
],
"tableData": [
  ["Leading Cab Companies in India", "Top Taxi Providers India"],
  ["Best Cab Brands India", "Trusted Cab Operators India"],
  ["Premier Cab Services India", "Nationwide Cab Companies"],
  ["Top Rated Taxi Companies India", "Renowned Cab Firms India"],
  ["India’s Leading Cab Services", "Large-scale Cab Networks India"],
  ["Most Popular Cab Companies India", "Elite Cab Operators India"],
  ["Top Car Hire Firms India", "High End Cab Networks India"],
  ["Leading Transport Services India", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "One of the Leading Cab Companies in India",
    "WhyChoosedescription": "Aaryan Travels is recognized as a trusted and top-rated cab service provider across major cities in India."
  },
  {
    "WhyChooseheading": "Extensive Network Covering Pan-India Locations",
    "WhyChoosedescription": "We operate in numerous cities and towns, offering seamless travel solutions anywhere in India."
  },
  {
    "WhyChooseheading": "Wide Range of Clean and Comfortable Vehicles",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers to suit your travel preferences and group size."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers Across India",
    "WhyChoosedescription": "Our drivers are trained, courteous, and familiar with local routes to provide safe and timely rides."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer upfront pricing including fuel, tolls, and driver allowances for a stress-free experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Smooth Booking and Assistance",
    "WhyChoosedescription": "Our support team is available around the clock to help with bookings, cancellations, and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Local and Outstation Travel",
    "WhyChoosedescription": "Whether it’s a short city ride or a long-distance journey, we provide customizable travel plans."
  },
  {
    "WhyChooseheading": "Commitment to Safety and Customer Satisfaction",
    "WhyChoosedescription": "We prioritize your safety and comfort with sanitized vehicles and courteous service at every step."
  }
]



































  }

const faqData = [
  {
    question: 'Is Aaryan Travels one of the leading cab companies in India?',
    answer: 'Yes, Aaryan Travels is recognized as one of the leading cab companies in India, offering reliable and professional cab services across multiple cities.',
  },
  {
    question: 'What types of cab services does Aaryan Travels offer across India?',
    answer: 'Aaryan Travels offers a variety of services including local cabs, outstation trips, corporate cabs, airport transfers, and hourly rentals across India.',
  },
  {
    question: 'How can I book cabs with Aaryan Travels anywhere in India?',
    answer: 'You can easily book cabs through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'Does Aaryan Travels have a presence in both metro and non-metro cities in India?',
    answer: 'Yes, Aaryan Travels operates in major metro cities as well as tier-2 and tier-3 cities across India.',
  },
  {
    question: 'Are Aaryan Travels drivers trained and professional throughout India?',
    answer: 'Absolutely. Our drivers are licensed, professional, and well-trained to ensure safe and comfortable travel anywhere in India.',
  },
  {
    question: 'Does Aaryan Travels provide corporate cab services across India?',
    answer: 'Yes, we offer customized corporate cab solutions for businesses nationwide with flexible billing and reliable service.',
  },
  {
    question: 'Is Aaryan Travels’ cab service available 24x7 across India?',
    answer: 'Yes, we provide round-the-clock cab services to cater to your travel needs at any time and place in India.',
  },
  {
    question: 'What safety and hygiene measures does Aaryan Travels follow across India?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene protocols to ensure passenger safety.',
  },
  {
    question: 'What payment options are accepted by Aaryan Travels in India?',
    answer: 'We accept multiple payment methods including cash, cards, UPI, and digital wallets for convenient transactions.',
  },
  {
    question: 'Can I customize pickup and drop-off locations anywhere in India?',
    answer: 'Yes, Aaryan Travels allows full customization of pickup and drop points as per your travel plans across India.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arjun Singh',
    feedback: 'Aaryan Travels is by far one of the best cab companies I have used in India. Professional and timely service everywhere I travel.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meera Rao',
    feedback: 'Their presence in multiple cities and excellent customer support make Aaryan Travels my go-to cab company across India.',
    rating: 5,
  },
];































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Leading Cab Companies in India",
  "image": "https://aaryantravels.com/assets/images/leading-cab-companies-india.jpg", // replace with actual image URL
  "description": "Aaryan Travels is among the leading cab companies in India, offering reliable, affordable, and premium taxi services for local, outstation, and corporate travel across the country.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // example rating, update as needed
    "ratingCount": "4200", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/leading-cab-companies-india"
  }
};






  return (
    <div>

<Helmet>
  <title>Leading Cab Companies in India | Trusted & Reliable Taxi Services | Aaryan Travels</title>
  <meta
    name="description"
    content="Aaryan Travels is among the leading cab companies in India, offering reliable, affordable, and premium taxi services for local, outstation, and corporate travel across the country."
  />
  <meta
    name="keywords"
    content="Leading Cab Companies in India, Top Taxi Providers India, Best Cab Brands India, Trusted Cab Operators India, Premier Cab Services India, Nationwide Cab Companies, Top Rated Taxi Companies India, Renowned Cab Firms India, India’s Leading Cab Services, Large-scale Cab Networks India, Most Popular Cab Companies India, Elite Cab Operators India, Top Car Hire Firms India, High End Cab Networks India, Leading Transport Services India"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/36.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Leadingcabcompaniesinindia;